import React from 'react';
import { Star, MapPin, Calendar } from 'lucide-react';
import { mockHotelData } from './mock';

const Hero = () => {
  const { hotel } = mockHotelData;

  return (
    <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src={hotel.heroImage}
          alt="Constantinou Bros Athena Beach Hotel"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/30 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center text-white px-6 max-w-4xl mx-auto">
        <div className="mb-6">
          <h1 className="text-5xl md:text-7xl font-bold mb-4 animate-fade-in">
            Our Cyprus Adventure
          </h1>
          <p className="text-xl md:text-2xl mb-8 font-light">
            7 magical nights at {hotel.name}
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-6 mb-8">
          <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
            <Star className="text-yellow-400 fill-current" size={20} />
            <span className="font-medium">{hotel.rating} Star Hotel</span>
          </div>
          
          <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
            <MapPin className="text-blue-400" size={20} />
            <span className="font-medium">{hotel.destination}</span>
          </div>
          
          <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
            <Calendar className="text-green-400" size={20} />
            <span className="font-medium">{hotel.checkIn} - {hotel.checkOut}</span>
          </div>
        </div>

        <div className="animate-bounce">
          <a href="#weather" className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-full font-medium transition-colors duration-200">
            Explore Our Journey
          </a>
        </div>
      </div>

      {/* Floating Elements */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white/50 rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;